import dayjs from 'dayjs'
import { isNull } from 'lodash'
import { computed, toValue } from 'vue'

import { getStartOfTheDay, localDateToUtc } from '@/utils/date'

export const useBackDate = ({ selectedDate = null }) => {
  const DATE_FORMAT = 'D MMM YYYY'

  const today = getStartOfTheDay(dayjs())

  const isTodaySelected = computed(() => {
    const resolvedSelectedDate = toValue(selectedDate)

    return isNull(resolvedSelectedDate) || Number(resolvedSelectedDate) === Number(today)
  })

  const notAfterToday = date => {
    return date.getTime() > new Date().getTime()
  }

  const getBackdateAsRequestParameter = computed(() => {
    if (isTodaySelected.value) return null

    const resolvedSelectedDate = toValue(selectedDate)

    return localDateToUtc(dayjs(resolvedSelectedDate).startOf('day'))
  })

  return {
    DATE_FORMAT,
    today,
    isTodaySelected,
    notAfterToday,
    getBackdateAsRequestParameter
  }
}
